import { GetterTree } from "vuex";
import { SettingsState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<SettingsState, any> = {
  [defineVuexName(MODULES.REALTIME_SETTINGS.GETTERS.GET_SETTINGS)](state: SettingsState) {
    return state.channels;
  },
};

export default getters;
